"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var alerts_component_1 = require("../../components/alerts.component");
var inputs_component_1 = require("../../components/inputs.component");
var interpolate_1 = require("../../utils/interpolate/interpolate");
var ajax_util_1 = require("../../utils/ajax/ajax.util");
var constants_1 = require("../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var passport_1 = require("../../actions/passport");
var passport_2 = require("../../utils/passport");
var commonweb_utils_1 = require("commonweb-utils");
var buttons_component_1 = require("../../components/buttons.component");
var page = require('page');
/**
 * TODO: move validation and form specific changes in HOC
 */
var UpdatePassport = /** @class */ (function (_super) {
    tslib_1.__extends(UpdatePassport, _super);
    function UpdatePassport(props) {
        var _this = _super.call(this, props) || this;
        _this.inputChangedHandler = function (event, inputIdentifier) {
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[inputIdentifier]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.isValid = _this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.isTouched = true;
            updatedForm[inputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier_1 in updatedForm) {
                formIsValid = updatedForm[inputIdentifier_1].isValid && formIsValid;
            }
            _this.setState({ form: updatedForm, formIsValid: formIsValid });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            var formData = {};
            for (var formElementIdentifier in _this.state.form) {
                formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
            }
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.PASSPORT.UPDATE, formData, { component: { name: VIEWS.UPDATE_PASSPORT } }).then(function (passportInfo) {
                if (passportInfo) {
                    _this.props.dispatchPassportChange(passportInfo);
                }
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PASSPORT.UPDATE_SUCCESS);
            }).catch(function (error) {
                var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, 'error.statusCode') || 500;
                if (errorStatusCode >= 400 && errorStatusCode < 500) {
                    _this.setState({ errorMessage: _this.props.content.passport.edit.passportError });
                }
                else {
                    _this.setState({ errorMessage: _this.props.content.passport.genericError });
                }
                return;
            });
        };
        var passportContent = props.content.passport, countryOptionLabel = { optionId: '', optionValue: passportContent.issuingCountry.label }, countryOptions = [countryOptionLabel].concat(props.passport.countryOptionList || []), selectedCountryOption = countryOptions.find(function (countryOption) {
            return countryOption.optionValue == props.passport.passportCountry;
        }) || countryOptionLabel;
        _this.state = {
            form: {
                passportNumberInput: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: passportContent.passport.label,
                        suggestionText: passportContent.passport.error
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    isValid: false,
                    isTouched: false
                },
                passportCountryInput: {
                    elementType: 'select',
                    elementConfig: {
                        options: countryOptions,
                        placeholder: passportContent.issuingCountry.label,
                        suggestionText: ''
                    },
                    value: selectedCountryOption.optionId,
                    validation: {
                        required: true
                    },
                    isValid: !!selectedCountryOption.optionId,
                    isTouched: !!selectedCountryOption.optionId
                }
            },
            formIsValid: false,
            errorMessage: ''
        };
        return _this;
    }
    UpdatePassport.prototype.checkValidity = function (value, rules) {
        var isValid = true;
        if (!rules) {
            return true;
        }
        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }
        /**
         * Examples of multiple validation rules on future
         * forms validation. will move to HOC
         *
         *
        // if (rules.minLength) {
        // 	isValid = value.length >= rules.minLength && isValid
        // 	}

        // if (rules.maxLength) {
        // 	isValid = value.length <= rules.maxLength && isValid
        // }

        // if (rules.isNumeric) {
        // 	const pattern = /^\d+$/;
        // 	isValid = pattern.test(value) && isValid
        // }
         */
        return isValid;
    };
    UpdatePassport.prototype.render = function () {
        var _this = this;
        var formElementsArray = [];
        var showSpinner = this.props.ui.showSpinner, passportInfo = this.props.passport, passportContent = this.props.content.passport;
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key]
            });
        }
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.errorMessage ?
                React.createElement(alerts_component_1.default, { alertType: 'critical', modifierClass: "form-alert", message: this.state.errorMessage })
                : null,
            React.createElement("h2", { className: "generic-header passport-header" }, passportContent.edit.header),
            passportInfo.passportNumber &&
                React.createElement("h4", { className: "generic-message" }, interpolate_1.default('inHTMLData', passportContent.edit.passportInfo, { passportNumber: passportInfo.passportNumber })),
            formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, value: formElement.config.value, isInvalid: !formElement.config.isValid, shouldValidate: formElement.config.validation, isTouched: formElement.config.isTouched, changed: function (event) { return _this.inputChangedHandler(event, formElement.id); } })); }),
            React.createElement(buttons_component_1.Button, { name: "passportUpdateSubmit", type: "submit", modifierClass: "test_submit vx_btn-block modal_btn", disabled: !this.state.formIsValid, content: this.props.content.common.next }),
            React.createElement(buttons_component_1.ButtonLink, { name: 'remove', content: this.props.content.common.remove, onClick: passport_2.onClickRemovePassport })));
        return (React.createElement("div", { className: "generic-container" }, showSpinner ? React.createElement("div", { className: 'panelSpinner' }) : form));
    };
    return UpdatePassport;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account;
    var passport = commonweb_utils_1.objectUtils.safeGet(account, 'passport') || {};
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        passport: passport
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPassportChange: function (passportInfo) { return dispatch(passport_1.changePassport(passportInfo)); },
        dispatch: dispatch
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdatePassport);
